import {Pipe, PipeTransform} from '@angular/core';

// Font Awesome 4 sin el mismo nombre en PrimeIcons 7. El resto se llama igual (fa-plus -> pi-plus).
const EQUIVALENTES: Record<string, string> = {
    'file-pdf-o': 'file-pdf', 'file-excel-o': 'file-excel', 'money': 'money-bill', 'file-text': 'file',
    'file-text-o': 'file', 'cutlery': 'shop', 'handshake-o': 'users', 'percent': 'percentage', 'list-ol': 'list',
    'paper-plane-o': 'send', 'archive': 'box', 'id-card-o': 'id-card', 'clock-o': 'clock', 'pie-chart': 'chart-pie',
    'university': 'building-columns', 'credit-card-alt': 'credit-card', 'exchange': 'arrow-right-arrow-left',
    'usd': 'dollar', 'tachometer': 'gauge', 'list-alt': 'list', 'address-card': 'id-card', 'balance-scale': 'wallet',
    'cubes': 'th-large', 'shopping-basket': 'shopping-bag', 'laptop': 'desktop', 'user-circle': 'user',
    'motorcycle': 'truck', 'user-secret': 'user', 'file-code-o': 'code', 'plus-square-o': 'plus-circle',
    'minus-square': 'minus-circle', 'random': 'sync', 'window-close-o': 'times-circle', 'gear': 'cog',
    'caret-square-o-up': 'caret-up', 'caret-square-o-down': 'caret-down', 'toggle-on': 'circle-on',
    'toggle-off': 'circle-off', 'external-link-square': 'external-link', 'trash-o': 'trash', 'picture-o': 'image',
    'dropbox': 'box', 'lemon-o': 'apple', 'glass': 'objects-column', 'sliders': 'sliders-h', 'list-ul': 'list',
    'commenting-o': 'comment', 'unlock-alt': 'unlock', 'certificate': 'verified', 'street-view': 'map-marker',
    'files-o': 'copy', 'cube': 'box', 'trademark': 'tag', 'calendar-check-o': 'calendar', 'hourglass-start': 'hourglass',
    'building-o': 'building', 'industry': 'warehouse', 'suitcase': 'briefcase', 'meetup': 'users',
    'file-archive-o': 'folder', 'sort-amount-desc': 'sort-amount-down', 'line-chart': 'chart-line',
    'folder-open-o': 'folder-open'
};

/**
 * La app solo usa PrimeIcons, pero los accesos directos guardados en el backend pueden traer clases de Font Awesome
 * ("fa fa-money"). Se traducen al icono equivalente de PrimeIcons; cualquier otra clase se devuelve tal cual.
 */
export function iconoPrime(clase: string): string {
    if (!clase || !/(^|\s)fa(\s|$)/.test(clase)) {
        return clase;
    }
    const icono = clase.split(/\s+/).map(c => c.startsWith('fa-') ? c.substring(3) : null)
        .find(nombre => nombre && nombre !== 'fw');
    return icono ? `pi pi-${EQUIVALENTES[icono] || icono}` : clase;
}

@Pipe({
    name: 'iconoPrime',
    standalone: true
})
export class IconoPrimePipe implements PipeTransform {
    transform(clase: string): string {
        return iconoPrime(clase);
    }
}
